// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"b4486c25","381":"a898925c","451":"f1b96c99","787":"dc05947b","793":"fd2bb8bc","916":"788e5559"}[chunkId] + ".chunk.js";
};